import axios from 'axios';

// The scanner PWA has its own login and its own session, independent of the admin dashboard's
// `access_token`, so a guard's phone never holds (or needs) an admin session.
const TOKEN_KEY = 'scanner_token';
const USER_KEY = 'scanner_user';

export const getScannerToken = () => localStorage.getItem(TOKEN_KEY);
export const getScannerUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || 'null');
  } catch {
    return null;
  }
};
export const setScannerSession = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || null));
};
export const clearScannerSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

const scannerApi = axios.create({ baseURL: process.env.REACT_APP_BASE_URL });

scannerApi.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${getScannerToken()}`;
  return config;
});

// expired/invalid session: drop it and let the app show the scanner login
scannerApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      clearScannerSession();
      window.dispatchEvent(new Event('scanner-logout'));
    }
    return Promise.reject(error);
  }
);

// Gate staff sign in with the email + password an admin set for them under Users > Security Form
export const scannerLogin = (email, password) => axios.post(`${process.env.REACT_APP_BASE_URL}/auth/scanner-login`, { email, password });

export default scannerApi;
